import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { RecoilRoot } from "recoil";
import "./App.css";
import Dashboard from "./Dashboard";

function App() {
  return (
    <RecoilRoot>
      <Router>
        <Dashboard />
      </Router>
    </RecoilRoot>
  );
}

export default App;
